import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';

const ReviewReply = styled.div`
	margin: 10px 0 0 5px;
	border-left: 3px solid #e0e0e0;
	padding: 5px 0 0 12px;
	line-height: 18px;
`;

const ReviewTime = styled.div`
	color: #b8b8b8;
`;

const ReviewStar = styled.i`
	color: #ff9602;
`;

const GoogleLogo = styled.img`
	max-width: 20px;
	padding-top: 5px;
`;

const Author = styled.span`
	padding-top: 4px;
	padding-bottom: 0px;
	display: inline-block;
	vertical-align: middle;
	line-height: normal;
	font-weight: bold;
`;

const Rating = styled.div`
	margin-left: -3px;
	margin-top: 5px;
`;

const padding = {
	padding: '0px'
};

const responseBody = {
	color: 'gray'
};

class GoogleReview extends Component {
	getTimeAgo = time => moment(time).fromNow();

	renderStars = () => {
		if (typeof this.props.rating === 'number') {
			return this.renderStarImages(this.props.rating);
		}
		const numberDictionary = { ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5 };
		return this.renderStarImages(numberDictionary[this.props.rating] || 0);
	};

	renderAuthor = () => <span>{this.props.author}</span>;

	renderResponse = () => {
		if (this.props.response) {
			return (
				<ReviewReply>
					<div style={responseBody}>
						You responded{' '}
						{this.getTimeAgo(this.props.response.updateTime)}:{' '}
						{this.props.response.comment}
					</div>
				</ReviewReply>
			);
		}

		return (
			<div style={{ responseBody }}>
				<p style={{ color: '#c655d6' }}>
					You have not responded to this review.
				</p>
			</div>
		);
	};

	renderStarImages = number => {
		const stars = [];
		for (let i = 0; i < number; i += 1) {
			stars.push(
				<ReviewStar className="material-icons" key={i}>
					star
				</ReviewStar>
			);
		}
		return stars;
	};

	renderIcon = () => {
		if (this.props.google) {
			return <GoogleLogo alt="google logo" src="/img/google-logo.png" />;
		}

		return (
			<img
				alt="bad review icon"
				className="google-logo"
				src="/img/bad-review.png"
			/>
		);
	};

	render() {
		return (
			<div>
				<div className="review row" style={padding}>
					<div
						className="col s1"
						style={{
							width: 'auto',
							paddingLeft: '0px',
							paddingRight: '0px',
							marginRight: '0px'
						}}
					>
						{this.renderIcon()}
					</div>
					<div className="col s11">
						<Author>{this.renderAuthor()}</Author>

						<Rating>{this.renderStars()}</Rating>
						<ReviewTime style={{ marginLeft: '5px' }}>
							{this.props.time}
						</ReviewTime>
						<div
							className="review-text"
							style={{ marginLeft: '5px' }}
						>
							{this.props.text}
						</div>
						{this.renderResponse()}
					</div>
				</div>
			</div>
		);
	}
}

export default GoogleReview;



// WEBPACK FOOTER //
// ./src/components/review/ReviewTable/Modal/GoogleReview.js